import { Box } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseShortOverviewSection: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => (
	<Box
		sx={{
			display: 'flex',
			gap: spaces.sm,
			overflow: 'hidden',
		}}
		data-testid="mui-card-mobile__visible-section"
	>
		{children}
	</Box>
);

export default MuiCardBaseShortOverviewSection;
